import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { NotificationCenter } from './components';
import AppRouter from './routes/AppRouter';
import './App.css';
import './variables.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});

export const getQueryClient = () => {
  return queryClient;
};

function App() {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <AppRouter />
        <NotificationCenter />
      </QueryClientProvider>
    </>
  );
}

export default App;
